import React from "react";

interface IndustryHeaderProps {
  title: React.ReactNode;
  subtitle: string;
  description: string;
  button?: React.ReactNode; // This is where your <PrimaryBtn /> goes
  mode?: "light" | "dark";
  classname?: string;
}

export default function IndustryHeader({
  title,
  subtitle,
  description,
  button,
  mode = "dark",
}: IndustryHeaderProps) {
  const isLight = mode === "light";

  return (
    <div
      className={`w-full ${isLight ? "2xl:pt-[80px] pt-[40px]" : "bg-transparent"} 2xl:pb-[40px] pb-[30px] `}
    >
      <div
        className={`max-w-[5000px] mx-auto ${isLight ? "w-[calc(100%_-_10%)]" : "w-full"}`}
      >
        <div className="flex flex-col">
          {/* Subtitle */}
          <p
            className={`text-base font-medium uppercase tracking-tight 
          ${isLight ? "text-[#00040B]" : "text-white"} mb-[20px] pb-[10px]`}
          >
            {subtitle}
          </p>

          {/* Main content row */}
          <div className="flex flex-col lg:flex-row justify-start items-start gap-y-6 lg:gap-x-10">
            <div className="w-full lg:max-w-[70%]">
              {/* Title */}
              <h2
                className={`text-[length:var(--industry-header-title)] font-medium clash-font leading-[1.1]
               ${isLight ? "text-black" : "text-white"} mb-[30px]`}
              >
                {title}
              </h2>

              {/* Description */}
              <p
                className={`text-[length:var(--industry-para)] leading-[1.7] ${
                  isLight ? "text-gray-600" : "text-white"
                } max-w-full lg:max-w-[90%]`}
                dangerouslySetInnerHTML={{ __html: description ?? "" }}
              />
            </div>

            {/* Button Slot - Optimized for PrimaryBtn */}
            {button && (
              <div className="flex-shrink-0 lg:ml-auto self-start lg:self-start bg-blue">
                {button}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
